const errors = {
  VALIDATION_ERROR: {
    code: 'VALIDATION_ERROR',
    message: 'Validation error',
    statusCode: 400,
  },
  AUTHORIZATION_ERROR: {
    code: 'AUTHORIZATION_ERROR',
    message: 'Authorization error',
    statusCode: 401,
  },
  FORBIDDEN_ERROR: {
    code: 'FORBIDDEN_ERROR',
    message: 'Forbidden error',
    statusCode: 403,
  },
  NOT_FOUND_ERROR: {
    code: 'NOT_FOUND_ERROR',
    message: 'Not found error',
    statusCode: 404,
  },
  INTERNAL_SERVER_ERROR: {
    code: 'INTERNAL_SERVER_ERROR',
    message: 'Internal Server Error',
    statusCode: 500,
  },
  NOT_CAPTURED: {
    code: 'NOT_CAPTURED',
    message: 'Your payment could not be completed.',
    statusCode: 400,
  },
  CREATE_PAYMENT_METHOD_FAILED: {
    code: 'CREATE_PAYMENT_METHOD_FAILED',
    message: 'Your payment method could not be saved.',
    statusCode: 400,
  },
  CARD_DECLINED: {
    code: 'CREATE_PAYMENT_METHOD_FAILED',
    message: 'Your payment method could not be saved.',
    details: [
      {
        code: 'CARD_DECLINED',
        message:
          'The card has been declined. Please review the card information, contact the card issuer, or use another card before creating the payment method.',
        details:
          'The card has been declined. Please review the card information, contact the card issuer, or use another card before creating the payment method.',
      },
    ],
    statusCode: 400,
  },
  PROCESSOR_CHARGE_ERROR: {
    code: 'CREATE_PAYMENT_METHOD_FAILED',
    message: 'Your payment method could not be saved.',
    details: [
      {
        code: 'PROCESSOR_CHARGE_ERROR',
        message:
          'The payment could not be processed. Please reach out for further information before creating the payment method.',
        details:
          'The payment could not be processed. Please reach out for further information before creating the payment method.',
      },
    ],
    statusCode: 400,
  },
  PAYMENT_METHOD_ERROR: {
    code: 'CREATE_PAYMENT_METHOD_FAILED',
    message: 'Your payment method could not be saved.',
    details: [
      {
        code: 'CARD_ERROR',
        message:
          'The card could not be verified. Please review the card information, use another card, or contact the card issuer for more information before creating the payment method.',
        details:
          'The card could not be verified. Please review the card information, use another card, or contact the card issuer for more information before creating the payment method.',
      },
    ],
    statusCode: 400,
  },
  CARD_INVALID: {
    code: 'CREATE_PAYMENT_METHOD_FAILED',
    message: 'Your payment method could not be saved.',
    details: [
      {
        code: 'CARD_INVALID',
        message:
          'The card could not be verified. Please review the card information, contact the card issuer, or use another card before creating the payment method.',
        details:
          'The card could not be verified. Please review the card information, contact the card issuer, or use another card before creating the payment method.',
      },
    ],
    statusCode: 400,
  },
  PROCESSOR_OUTAGE: {
    code: 'CREATE_PAYMENT_METHOD_FAILED',
    message: 'Your payment method could not be saved.',
    details: [
      {
        code: 'PROCESSOR_OUTAGE',
        message:
          'The card processor is experiencing a temporary outage. Please wait a moment before creating the payment method.',
        details:
          'The card processor is experiencing a temporary outage. Please wait a moment before creating the payment method.',
      },
    ],
    statusCode: 400,
  },
  SANDBOX_INVALID_BANK_ACCOUNT_ERROR: {
    code: 'SANDBOX_INVALID_PAYLOAD',
    message:
      'The request payload contains information that is not valid for use in the Sandbox',
    details: [
      {
        code: 'SANDBOX_INVALID_BANK_ACCOUNT_DETAILS',
        message:
          'The provided BANK_ACCOUNT accountNumber and routingNumber combination is not supported in the Sandbox.',
        details:
          'The provided BANK_ACCOUNT accountNumber and routingNumber combination is not supported in the Sandbox.',
      },
    ],
    statusCode: 400,
  },
  SANDBOX_INVALID_CARD_ERROR: {
    code: 'SANDBOX_INVALID_PAYLOAD',
    message:
      'The request payload contains information that is not valid for use in the Sandbox',
    details: [
      {
        code: 'SANDBOX_INVALID_CARD_DETAILS',
        message:
          'The provided CARD accountNumber is not supported in the Sandbox.',
        details:
          'The provided CARD accountNumber is not supported in the Sandbox.',
      },
    ],
    statusCode: 400,
  },
}

module.exports = {
  errors,
}
